export default "__VITE_ASSET__UvZeOROr__"